// uploadFile.js
import SparkMD5 from 'spark-md5'
import { getStorage } from './utils.js'

// rewrite readAsBinaryString
FileReader.prototype.readAsBinaryString = function (fileData) {
  let binary = ''
  let pt = this
  let reader = new FileReader()
  reader.onload = function (e) {
    let bytes = new Uint8Array(reader.result)
    let length = bytes.byteLength
    for (let i = 0; i < length; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    pt.content = binary
    pt.onload(pt) // 页面内data取pt.content文件内容
  }
  reader.readAsArrayBuffer(fileData)
}

// currentChunk为上传文件块的索引
export const uploadChunk = (data, that, file, callback) => {
  // console.log('uploadChunk')

  // 上传文件块的大小，后台返回
  let chunkSize = data.splitChunkSize
  let chunks = data.splitCount
  let maxCount = data.threadMaxCount
  // 计算改文件的可分为多少块

  // 处理单片文件的上传
  function loadNext () {
    for (let i = 0; i < chunks; i++) {
      let fileReader = new FileReader()
      let currentChunk = i + 1
      let start = i * chunkSize
      let end = Math.min(start + chunkSize, file.size)
      // 切割文件并触发fileReader.onload
      fileReader.readAsArrayBuffer(file.slice(start, end))
      // 文件切割后的回调，this.result为切割的文件块
      fileReader.onload = function (e) {
        // 用FormData传输文件对象
        let fd = new FormData()
        that.isUploading = false
        // 设置上传的当前的文件块
        fd.append('file', new Blob([this.result]))
        // console.log('sleep-->5s')
        let val = maxCount / currentChunk
        if (currentChunk !== 1 && Math.round(val) === val) {
          sleep(5000) // wait 0.5s
        }
        uploadChunk_(currentChunk, chunks, data, fd, that, callback)
        // that.uploadFileRequest('http://192.168.15.229:8099/upload?chunkID=' + currentChunk + '&&fileGUID=' + data.fileGUID + '', fd).then(res => {
        //   if (res.data.code === 1) {
        //     that.$message({message: '上传失败：' + res.data.message, type: 'error'})
        //   } else if (res.data.code === 100) {
        //   } else {
        //     if (currentChunk >= chunks) {
        //       callback && callback()
        //     }
        //   }
        // })
        fd = null
      }
    }
  }
  // 触发文件第一块上传
  loadNext()
}

function uploadChunk_ (currentChunk, chunks, data, fd, that, callback) {
  // that.uploadFileDo(getStorage('externalNginxUrl') + '/gcloudadmin_/upload/?chunkID=' + currentChunk + '&fileGUID=' + data.fileGUID + '', fd).then(res => {
  that.uploadFileDo(getStorage('externalNginxUrl') + '/gcloudadmin/upload/?chunkID=' + currentChunk + '&fileGUID=' + data.fileGUID + '', fd).then(res => {
    if (res && res.data) {
      if (res.data.code === 1) {
        that.$message({message: '上传失败：' + res.data.message, type: 'error'})
      } else if (res.data.code === 100) {
        uploadChunk_(currentChunk, chunks, data, fd, that, callback)
      } else {
        if (currentChunk >= chunks) {
          callback && callback()
        }
      }
    } else {
      that.$message({message: '上传失败,请稍后再试', type: 'error'})
    }
  })
}

function sleep (numberMillis) {
  let now = new Date()
  let exitTime = now.getTime() + numberMillis
  while (true) {
    now = new Date()
    if (now.getTime() > exitTime) {
      return
    }
  }
}

export const getFileSize = (size) => {
  if (size === 0) {
    return '0GB'
  }
  if (!size) {
    return ''
  }
  if (typeof size === 'string') {
    return size
  }
  return size > 1024 ? size / 1024 > 1024 ? size / (1024 * 1024) > 1024 ? (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB' : (size / (1024 * 1024)).toFixed(2) + 'MB' : (size / 1024).toFixed(2) + 'KB' : (size).toFixed(2) + 'B'
}

// 获得文件md5
export const getFileMD5 = (file, callback) => {
  // 声明必要的变量
  let fileReader = new FileReader()
  // 文件每块分割2M，计算分割详情
  let chunkSize = 2097152
  let chunks = Math.ceil(file.size / chunkSize)
  let currentChunk = 0

  // 创建md5对象（基于SparkMD5）
  let spark = new SparkMD5()

  // 每块文件读取完毕之后的处理
  fileReader.onload = function (e) {
    // 每块交由sparkMD5进行计算
    let tar = null
    if (!e.target) {
      tar = fileReader.content
    } else {
      tar = e.target.result
    }
    spark.appendBinary(tar)
    currentChunk++

    // 如果文件处理完成计算MD5，如果还有分片继续处理
    if (currentChunk < chunks) {
      loadNext()
    } else {
      callback(spark.end())
    }
  }

  // 处理单片文件的上传
  function loadNext () {
    let start = currentChunk * chunkSize
    let end = start + chunkSize >= file.size ? file.size : start + chunkSize
    fileReader.readAsBinaryString(file.slice(start, end))
  }
  loadNext()
}



// WEBPACK FOOTER //
// ./src/utils/upload.js